import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

export type QuickFilterBarProps = BoxProps & {
  children: ReactNode;
};

export function QuickFilterBar({
  children,
  sx,
  ...boxProps
}: QuickFilterBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
}
